var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphs/driver (black)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOG-table",
    transform: "translate(-1505.000000, -165.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphs/driver-(black)",
    transform: "translate(1506.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.6704851,22 C17.6801267,21.7384169 17.6830325,21.4806491 17.6830325,21.23 C17.6830325,18.3746878 14.6606225,16.06 10.9322908,16.06 C7.20395909,16.06 4.18154907,18.3746878 4.18154907,21.23 C4.18154907,21.4831235 4.18384636,21.740673 4.1925036,22 L1.44174234,22 L-0.251920771,18.5010665 C0.526593086,17.0707918 1.35437299,15.6745593 2.23141894,14.3123688 C2.37001713,14.097104 2.50984565,13.8826893 2.65090449,13.6691247 C4.44006811,10.9603122 7.43176173,9.28991459 10.6732674,9.18561731 L10.6732674,9.17831899 C10.7558194,9.17831899 10.8383118,9.17891637 10.9207446,9.18011114 C11.0031775,9.17891637 11.0856699,9.17831899 11.1682218,9.17831899 C11.1682218,9.18074985 11.1682218,9.18318262 11.1682218,9.18561731 C14.4097275,9.28991459 17.4014212,10.9603122 19.1905848,13.6691247 C19.3316436,13.8826893 19.4714721,14.097104 19.6100703,14.3123688 C20.4871163,15.6745593 21.3148962,17.0707918 22.09341,18.5010665 L20.3997469,22 L17.6704851,22 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0180316,22 C16.0180316,19.2023134 13.9768847,17.6 10.9322798,17.6 C7.88767488,17.6 5.83784076,19.225088 5.83784076,22 C8.73342078,22 9.89902954,22 16.0180316,22 Z",
    id: "Oval-Copy-7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.9322798,
    cy: 4.29,
    rx: 3.81188119,
    ry: 4.29
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIconBlack);
export default __webpack_public_path__ + "static/media/driver_icon_black.2e6bac54d52233df6c8f0e5eaf23c8ec.svg";
export { ForwardRef as ReactComponent };